/* CLEANOVA – Gallery + Variants + Bundle Add-to-Cart + Sticky ATC + Scroll Reveal */
(function () {
  'use strict';

  /* -----------------------------------------------------
     0. CART DRAWER AUTO-OPEN (universal helper)
     Tries every known method to open Horizon's cart drawer.
     Called by both the bundle and the regular ATC flow.
     ----------------------------------------------------- */
  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) {
      console.warn('[Cleanova] No cart-drawer-component found, redirecting to /cart');
      window.location.href = '/cart';
      return false;
    }

    // Force the auto-open attribute so Horizon's internal listener triggers too
    if (!drawer.hasAttribute('auto-open')) drawer.setAttribute('auto-open', '');

    // Try every known opening method
    try {
      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      if (typeof drawer.showDialog === 'function') {
        drawer.showDialog();
        return true;
      }
      // Fallback: directly open the <dialog ref="dialog"> element
      var dialogEl = drawer.querySelector('dialog[ref="dialog"], dialog');
      if (dialogEl && typeof dialogEl.showModal === 'function') {
        dialogEl.showModal();
        return true;
      }
      // Last resort: click the cart icon button
      var trigger = drawer.querySelector('[on\\:click="/open"], [data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return true;
      }
    } catch (e) {
      console.error('[Cleanova] Could not open cart drawer:', e);
    }

    console.warn('[Cleanova] All open methods failed, redirecting to /cart');
    window.location.href = '/cart';
    return false;
  }

  /* Listen for Horizon's native cart:update event (fired by product-form.js when ATC succeeds)
     and automatically open the drawer. This handles the regular Add-to-Cart button. */
  document.addEventListener('cart:update', function (e) {
    // Skip if our bundle code is handling it (it opens the drawer itself after section refresh)
    if (e.detail && e.detail.source === 'cleanova-bundle') return;
    if (e.detail && e.detail.didError) return;
    // Slight delay so cart sections finish morphing
    setTimeout(openCartDrawer, 150);
  });

  /* -----------------------------------------------------
     1. GALLERY THUMBNAIL SWAP
     ----------------------------------------------------- */
  document.querySelectorAll('[data-cleanova-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-cleanova-main-image]');
    var thumbs  = gallery.querySelectorAll('.cn-gallery-thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var newSrc = thumb.getAttribute('data-full-image');
        var newAlt = thumb.getAttribute('data-full-alt') || '';
        if (!newSrc || mainImg.src === newSrc) return;
        swapMainImage(newSrc, newAlt);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        scrollThumbIntoView(thumb);
      });
    });

    /* --- Arrow navigation: cycle through thumbs --- */
    var prevBtn = gallery.querySelector('[data-cleanova-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-cleanova-gallery-next]');

    function currentIndex() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function goToIndex(idx) {
      if (idx < 0) idx = thumbs.length - 1;
      if (idx >= thumbs.length) idx = 0;
      var thumb = thumbs[idx];
      if (!thumb) return;
      var newSrc = thumb.getAttribute('data-full-image');
      var newAlt = thumb.getAttribute('data-full-alt') || '';
      if (!newSrc) return;
      swapMainImage(newSrc, newAlt);
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      scrollThumbIntoView(thumb);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        goToIndex(currentIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        goToIndex(currentIndex() + 1);
      });
    }

    /* --- Thumbnail strip slider: nav arrows + keep active thumb in view --- */
    var thumbsStrip = gallery.querySelector('[data-cleanova-thumbs]');
    var thumbsPrev  = gallery.querySelector('[data-cleanova-thumbs-prev]');
    var thumbsNext  = gallery.querySelector('[data-cleanova-thumbs-next]');

    function updateThumbArrows() {
      if (!thumbsStrip) return;
      var overflow = thumbsStrip.scrollWidth - thumbsStrip.clientWidth;
      if (thumbsPrev) thumbsPrev.disabled = overflow <= 2 || thumbsStrip.scrollLeft <= 1;
      if (thumbsNext) thumbsNext.disabled = overflow <= 2 || thumbsStrip.scrollLeft >= overflow - 1;
    }

    function scrollThumbIntoView(thumb) {
      if (!thumbsStrip || !thumb) return;
      var target = thumb.offsetLeft - (thumbsStrip.clientWidth - thumb.offsetWidth) / 2;
      thumbsStrip.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    if (thumbsStrip) {
      var thumbStep = function () { return Math.max(thumbsStrip.clientWidth * 0.8, 120); };
      if (thumbsPrev) thumbsPrev.addEventListener('click', function (e) {
        e.preventDefault();
        thumbsStrip.scrollBy({ left: -thumbStep(), behavior: 'smooth' });
      });
      if (thumbsNext) thumbsNext.addEventListener('click', function (e) {
        e.preventDefault();
        thumbsStrip.scrollBy({ left: thumbStep(), behavior: 'smooth' });
      });
      thumbsStrip.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateThumbArrows);
      }, { passive: true });
      window.addEventListener('resize', updateThumbArrows);
      updateThumbArrows();
    }

    /* Keyboard support: arrow keys when gallery is focused/hovered */
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goToIndex(currentIndex() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goToIndex(currentIndex() + 1); }
    });
  });

  function swapMainImage(newSrc, newAlt) {
    var mainImg = document.querySelector('[data-cleanova-main-image]');
    if (!mainImg || !newSrc || mainImg.src === newSrc) return;

    mainImg.style.transition = 'opacity 0.25s ease';
    mainImg.style.opacity = '0';

    var preloader = new Image();
    preloader.onload = function () {
      mainImg.src = newSrc;
      if (newAlt) mainImg.alt = newAlt;
      requestAnimationFrame(function () { mainImg.style.opacity = '1'; });
    };
    preloader.onerror = function () { mainImg.style.opacity = '1'; };
    preloader.src = newSrc;

    var thumbs = document.querySelectorAll('.cn-gallery-thumb');
    thumbs.forEach(function (t) {
      if (t.getAttribute('data-full-image') === newSrc) {
        thumbs.forEach(function (tt) { tt.classList.remove('is-active'); });
        t.classList.add('is-active');
      }
    });
  }

  /* -----------------------------------------------------
     1b. FULL-SIZE IMAGE LIGHTBOX
     Tap the main product image to view it full screen.
     Navigate with arrows; close by tapping outside, the ✕, or Esc.
     ----------------------------------------------------- */
  (function () {
    var mainImg = document.querySelector('[data-cleanova-main-image]');
    if (!mainImg) return;

    var thumbEls = Array.prototype.slice.call(document.querySelectorAll('.cn-gallery-thumb'));
    // Build the ordered list of full-size sources (thumbs in DOM order, or just the main image).
    var slides = thumbEls.length
      ? thumbEls.map(function (t) {
          return { src: t.getAttribute('data-full-image'), alt: t.getAttribute('data-full-alt') || '' };
        }).filter(function (s) { return s.src; })
      : [{ src: mainImg.getAttribute('src'), alt: mainImg.getAttribute('alt') || '' }];

    if (!slides.length) return;

    var current = 0;

    // Build the lightbox DOM once.
    var box = document.createElement('div');
    box.className = 'cn-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-hidden', 'true');
    box.innerHTML =
      '<button type="button" class="cn-lightbox-close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>' +
      '</button>' +
      '<button type="button" class="cn-lightbox-nav cn-lightbox-prev" aria-label="Previous image">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<img class="cn-lightbox-img" alt="">' +
      '<button type="button" class="cn-lightbox-nav cn-lightbox-next" aria-label="Next image">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
      '</button>';
    document.body.appendChild(box);

    var boxImg  = box.querySelector('.cn-lightbox-img');
    var closeBtn = box.querySelector('.cn-lightbox-close');
    var prevBtn = box.querySelector('.cn-lightbox-prev');
    var nextBtn = box.querySelector('.cn-lightbox-next');

    // Hide nav arrows when there's only a single image.
    if (slides.length < 2) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }

    function render() {
      var s = slides[current];
      boxImg.src = s.src;
      boxImg.alt = s.alt;
    }

    function findCurrentFromMain() {
      var src = mainImg.getAttribute('src');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].src === src) return i;
      }
      return 0;
    }

    function open() {
      current = findCurrentFromMain();
      render();
      box.classList.add('is-open');
      box.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    function go(delta) {
      current = (current + delta + slides.length) % slides.length;
      render();
      // Keep the gallery's main image in sync with the lightbox.
      swapMainImage(slides[current].src, slides[current].alt);
    }

    mainImg.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    boxImg.addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); go(1); });

    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft' && slides.length > 1) go(-1);
      else if (e.key === 'ArrowRight' && slides.length > 1) go(1);
    });

    // Swipe support on touch devices.
    var touchX = null;
    box.addEventListener('touchstart', function (e) {
      touchX = e.changedTouches[0].clientX;
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (touchX === null || slides.length < 2) { touchX = null; return; }
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
      touchX = null;
    }, { passive: true });
  })();

  /* -----------------------------------------------------
     2. VARIANT SELECTION
     ----------------------------------------------------- */
  var variantDataEl = document.querySelector('[data-cleanova-variants]');
  var variants = [];
  if (variantDataEl) {
    try { variants = JSON.parse(variantDataEl.textContent); }
    catch (e) { console.warn('Cleanova: variant data parse failed', e); }
  }

  if (variants.length) {
    var atcLabelEl = document.querySelector('[data-cleanova-atc-label]');
    var baseAtcText = atcLabelEl
      ? atcLabelEl.textContent.split('—')[0].trim()
      : 'Add to Cart';

    document.querySelectorAll('.cn-variant-group').forEach(function (group) {
      var pills = group.querySelectorAll('.cn-variant-pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');

          var labelTarget = group.querySelector('[data-cleanova-selected-value]');
          if (labelTarget) labelTarget.textContent = pill.getAttribute('data-option-value');

          updateSelectedVariant();
        });
      });
    });

    function getSelectedOptions() {
      var selected = [];
      document.querySelectorAll('.cn-variant-group').forEach(function (group) {
        var pos = parseInt(group.getAttribute('data-option-position'), 10);
        var chosen = group.querySelector('.cn-variant-pill.is-selected');
        if (chosen) selected[pos] = chosen.getAttribute('data-option-value');
      });
      return selected;
    }

    function findMatchingVariant(selected) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function updateSelectedVariant() {
      var selected = getSelectedOptions();
      var variant = findMatchingVariant(selected);
      if (!variant) return;

      var idInput = document.querySelector('[data-cleanova-variant-id]');
      if (idInput) idInput.value = variant.id;

      var priceEl = document.querySelector('[data-cleanova-price]');
      if (priceEl) priceEl.textContent = variant.price_formatted;

      var compareEl = document.querySelector('[data-cleanova-compare]');
      var saveEl = document.querySelector('[data-cleanova-save]');
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        if (hasCompare) {
          compareEl.textContent = variant.compare_at_price_formatted;
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', '');
        }
      }
      if (saveEl) {
        if (hasCompare) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          saveEl.textContent = 'Save ' + pct + '%';
          saveEl.removeAttribute('hidden');
        } else {
          saveEl.setAttribute('hidden', '');
        }
      }

      if (atcLabelEl) atcLabelEl.textContent = baseAtcText + ' — ' + variant.price_formatted;

      var stickyPrice = document.querySelector('[data-cleanova-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = variant.price_formatted;

      if (variant.featured_image) {
        swapMainImage(variant.featured_image, variant.featured_image_alt || '');
        var stickyImg = document.querySelector('[data-cleanova-sticky-image]');
        if (stickyImg) stickyImg.src = variant.featured_image;
      }

      // Recalculate bundle totals if function is in scope
      if (typeof recalcBundle === 'function') recalcBundle();

      var atcBtn = document.querySelector('[data-cleanova-atc-button]');
      if (atcBtn) {
        if (!variant.available) {
          atcBtn.setAttribute('disabled', '');
          if (atcLabelEl) atcLabelEl.textContent = 'Sold Out';
          atcBtn.style.opacity = '0.5';
          atcBtn.style.cursor = 'not-allowed';
        } else {
          atcBtn.removeAttribute('disabled');
          atcBtn.style.opacity = '';
          atcBtn.style.cursor = '';
        }
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }
  }

  /* -----------------------------------------------------
     3. BUNDLE — Live totals + add multiple items to cart
     ----------------------------------------------------- */
  var bundleEl = document.querySelector('[data-cleanova-bundle]');
  var bundleBtn = document.querySelector('[data-cleanova-bundle-add]');

  // Parse shop money format for accurate JS formatting
  var shopConfig = { moneyFormat: '${{amount}}', currency: 'USD', currencySymbol: '$' };
  var shopConfigEl = document.querySelector('[data-cleanova-shop-config]');
  if (shopConfigEl) {
    try { shopConfig = JSON.parse(shopConfigEl.textContent); } catch (e) {}
  }

  // Format cents → money string using shop's money_format (e.g. "€{{amount}}")
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var format = shopConfig.moneyFormat || '${{amount}}';
    // Handle {{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}}
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100).toString());
  }

  // Recalculate bundle totals on every checkbox change
  function recalcBundle() {
    if (!bundleEl) return;
    var discountPct = parseFloat(bundleEl.getAttribute('data-discount-pct')) || 0;

    var subtotal = 0;           // current price × selected
    var compareTotal = 0;       // compare-at price × selected
    var selectedCount = 0;

    // Add-on products
    bundleEl.querySelectorAll('[data-bundle-variant-id]').forEach(function (cb) {
      if (cb.checked && !cb.disabled) {
        var price = parseInt(cb.getAttribute('data-price'), 10) || 0;
        var compare = parseInt(cb.getAttribute('data-compare'), 10) || price;
        subtotal += price;
        compareTotal += compare;
        selectedCount += 1;
      }
    });

    // Apply % discount
    var discountAmount = Math.round(subtotal * (discountPct / 100));
    var finalTotal = subtotal - discountAmount;
    var saveAmount = compareTotal - finalTotal;

    // Update DOM
    var totalEl = bundleEl.querySelector('[data-bundle-total]');
    var strikeEl = bundleEl.querySelector('[data-bundle-strike]');
    var saveEl = bundleEl.querySelector('[data-bundle-save]');
    var saveAmountEl = bundleEl.querySelector('[data-bundle-save-amount]');
    var emptyEl = bundleEl.querySelector('[data-bundle-empty]');

    if (totalEl) totalEl.textContent = formatMoney(finalTotal);
    if (strikeEl) {
      if (compareTotal > finalTotal) {
        strikeEl.textContent = formatMoney(compareTotal);
        strikeEl.style.display = '';
      } else {
        strikeEl.style.display = 'none';
      }
    }
    if (saveEl && saveAmountEl) {
      if (saveAmount > 0) {
        saveAmountEl.textContent = formatMoney(saveAmount);
        saveEl.removeAttribute('hidden');
      } else {
        saveEl.setAttribute('hidden', '');
      }
    }
    if (emptyEl) {
      if (selectedCount === 0) {
        emptyEl.removeAttribute('hidden');
      } else {
        emptyEl.setAttribute('hidden', '');
      }
    }

    // Disable button if nothing selected
    if (bundleBtn) {
      if (selectedCount === 0) {
        bundleBtn.setAttribute('disabled', '');
        bundleBtn.style.opacity = '0.5';
        bundleBtn.style.cursor = 'not-allowed';
      } else if (!bundleBtn.dataset.cleanovaBusy) {
        bundleBtn.removeAttribute('disabled');
        bundleBtn.style.opacity = '';
        bundleBtn.style.cursor = '';
      }
    }
  }

  // Wire up checkbox listeners for live recalculation
  if (bundleEl) {
    bundleEl.querySelectorAll('[data-bundle-variant-id]').forEach(function (cb) {
      cb.addEventListener('change', recalcBundle);
    });
    // Initial calc on load (handles variant changes from server)
    recalcBundle();
  }

  // Premium toast notification (replaces alert)
  function showBundleToast(message, type) {
    type = type || 'info';
    var toast = document.createElement('div');
    toast.className = 'cn-toast cn-toast--' + type;
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 350);
    }, 2800);
  }

  if (bundleBtn) {
    bundleBtn.addEventListener('click', function () {
      // Race protection: prevent double-clicks
      if (bundleBtn.dataset.cleanovaBusy === '1') return;

      var originalLabelEl = bundleBtn.querySelector('[data-bundle-cta-label]');
      var originalLabel = originalLabelEl ? originalLabelEl.textContent : 'Add to Cart';

      // Collect items
      var items = [];

      bundleEl.querySelectorAll('[data-bundle-variant-id]').forEach(function (cb) {
        if (cb.checked && !cb.disabled) {
          var vid = parseInt(cb.getAttribute('data-bundle-variant-id'), 10);
          if (vid) items.push({ id: vid, quantity: 1 });
        }
      });

      // Dedupe: if the same variant ID appears twice, merge into one line with summed quantity
      // (prevents the bundle from creating duplicate cart lines for the same product)
      var dedupedMap = {};
      items.forEach(function (it) {
        if (dedupedMap[it.id]) {
          dedupedMap[it.id].quantity += it.quantity;
        } else {
          dedupedMap[it.id] = { id: it.id, quantity: it.quantity };
        }
      });
      items = Object.keys(dedupedMap).map(function (k) { return dedupedMap[k]; });

      if (items.length === 0) {
        showBundleToast('Please select at least one item.', 'warning');
        return;
      }

      // Set busy state — prevent re-entry
      bundleBtn.dataset.cleanovaBusy = '1';
      bundleBtn.setAttribute('disabled', '');
      bundleBtn.style.opacity = '0.7';
      if (originalLabelEl) originalLabelEl.textContent = 'Adding…';

      // Validate every item has a real variant ID (catches misconfigured bundles)
      var invalidItems = items.filter(function (it) { return !it.id || isNaN(it.id) || it.id < 1; });
      if (invalidItems.length > 0) {
        showBundleToast('Bundle is misconfigured. Please contact support.', 'error');
        console.error('[Cleanova Bundle] Invalid items:', invalidItems, 'all items:', items);
        delete bundleBtn.dataset.cleanovaBusy;
        bundleBtn.removeAttribute('disabled');
        bundleBtn.style.opacity = '';
        if (originalLabelEl) originalLabelEl.textContent = originalLabel;
        return;
      }

      console.log('[Cleanova Bundle] Sending items to /cart/add.js:', items);

      // STEP 1 — Add all items to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          console.log('[Cleanova Bundle] Response status:', res.status, 'content-type:', res.headers.get('content-type'));
          return res.text().then(function (txt) {
            var data = null;
            try { data = JSON.parse(txt); } catch (e) { /* not JSON */ }

            if (!res.ok) {
              console.error('[Cleanova Bundle] Cart error response:', res.status, txt.substring(0, 500));
              var msg;
              if (data && (data.description || data.message)) {
                msg = data.description || data.message;
              } else if (res.status === 404) {
                msg = 'A bundle product is unavailable. Please refresh the page.';
              } else if (res.status === 422) {
                msg = 'A bundle product is sold out or has restrictions.';
              } else if (res.status >= 500) {
                msg = 'Shopify is having issues. Please try again in a moment.';
              } else {
                msg = 'Could not add to cart (status ' + res.status + ').';
              }
              throw new Error(msg);
            }

            return data || {};
          });
        })
        .then(function () {
          // STEP 2 — Server has new items. Now fetch fresh HTML for cart drawer section
          // and morph it into the DOM so the drawer shows up-to-date content.
          if (originalLabelEl) originalLabelEl.textContent = '✓ Added to Cart';
          bundleBtn.style.background = 'var(--cn-accent)';
          bundleBtn.style.borderColor = 'var(--cn-accent)';
          bundleBtn.style.color = '#fff';

          // Find the cart drawer's section ID (it's wrapped in <div id="shopify-section-{id}">)
          var cartDrawerEl = document.querySelector('cart-drawer-component');
          var cartDrawerSection = cartDrawerEl ? cartDrawerEl.closest('[id^="shopify-section-"]') : null;
          var cartIconEl = document.querySelector('cart-icon-component');
          var cartIconSection = cartIconEl ? cartIconEl.closest('[id^="shopify-section-"]') : null;

          var sectionsToRefresh = [];
          if (cartDrawerSection) {
            sectionsToRefresh.push(cartDrawerSection.id.replace('shopify-section-', ''));
          }
          if (cartIconSection) {
            var iconSid = cartIconSection.id.replace('shopify-section-', '');
            if (sectionsToRefresh.indexOf(iconSid) === -1) sectionsToRefresh.push(iconSid);
          }

          console.log('[Cleanova Bundle] Refreshing sections:', sectionsToRefresh);

          if (sectionsToRefresh.length === 0) {
            // No sections to refresh (drawer might not exist). Just dispatch event.
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { source: 'cleanova-bundle' }
            }));
            return Promise.resolve();
          }

          // Fetch fresh HTML for each section via Shopify Section Rendering API
          var refreshPromises = sectionsToRefresh.map(function (sectionId) {
            var url = new URL(window.location.href);
            url.searchParams.set('section_id', sectionId);
            return fetch(url.toString())
              .then(function (r) { return r.ok ? r.text() : null; })
              .then(function (html) {
                if (!html) return;
                // Parse fetched HTML and replace the live section element
                try {
                  var parser = new DOMParser();
                  var doc = parser.parseFromString(html, 'text/html');
                  var newSection = doc.getElementById('shopify-section-' + sectionId);
                  var oldSection = document.getElementById('shopify-section-' + sectionId);
                  if (newSection && oldSection) {
                    // Preserve dialog open state by replacing innerHTML, not the element itself
                    oldSection.innerHTML = newSection.innerHTML;
                    console.log('[Cleanova Bundle] Refreshed section:', sectionId);
                  }
                } catch (e) {
                  console.error('[Cleanova Bundle] Could not parse section HTML:', sectionId, e);
                }
              })
              .catch(function (e) {
                console.error('[Cleanova Bundle] Failed to fetch section', sectionId, e);
              });
          });

          return Promise.all(refreshPromises).then(function () {
            // Dispatch event for any other listeners that care about cart updates
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { source: 'cleanova-bundle' }
            }));
          });
        })
        .then(function () {
          // STEP 3 — Open the drawer (it now has fresh content)
          // Re-query after morph since innerHTML was replaced
          openCartDrawer();

          // Reset button state after drawer animation
          setTimeout(function () {
            delete bundleBtn.dataset.cleanovaBusy;
            bundleBtn.removeAttribute('disabled');
            bundleBtn.style.opacity = '';
            bundleBtn.style.background = '';
            bundleBtn.style.borderColor = '';
            bundleBtn.style.color = '';
            if (originalLabelEl) originalLabelEl.textContent = originalLabel;
            recalcBundle();
          }, 1200);
        })
        .catch(function (err) {
          console.error('[Cleanova Bundle]', err);
          showBundleToast(err.message || 'Could not add to cart. Please try again.', 'error');
          if (originalLabelEl) originalLabelEl.textContent = originalLabel;
          delete bundleBtn.dataset.cleanovaBusy;
          bundleBtn.removeAttribute('disabled');
          bundleBtn.style.opacity = '';
        });
    });
  }

  /* -----------------------------------------------------
     4. STICKY ADD TO CART
     ----------------------------------------------------- */
  var stickyBar = document.querySelector('.cn-sticky-atc');
  var mainATC   = document.querySelector('[data-cleanova-main-atc]');

  if (stickyBar && mainATC) {
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      },
      { threshold: 0 }
    );
    observer.observe(mainATC);

    var stickyBtn = stickyBar.querySelector('.cn-sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var realBtn = mainATC.querySelector('button[type="submit"], .product-form__submit');
        if (realBtn) {
          realBtn.click();
        } else {
          mainATC.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }

  /* -----------------------------------------------------
     5. SCROLL REVEAL
     ----------------------------------------------------- */
  var revealEls = document.querySelectorAll('.cleanova-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  }
})();